/**
 * Created by hp on 2017/7/5.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import WKDialog from '../../components/WKDialog';
import tipsImg from '../../images/no-listen-class3.png';
import sendImg from '../../images/classroom/icon-sound.png';
import '../../styles/classroom/ClassroomNoListenDialog.css';

class ClassroomNoListenDialog extends Component {
    constructor() {
        super();

        this.handleNo = this.handleNo.bind(this);
        this.handleYes = this.handleYes.bind(this);
        this.state = {
            confirmStyle: {
                noText: '知道了',
                yesText: '下载App',
                clickNoHandle: this.handleNo,
                clickYesHandle: this.handleYes,
            }
        }
    }

    handleNo() {
        this.props.dispatch({type: 'CLASSROOM_HIDE_NOLISTEN_DIALOG'});
        if (this.props.noTipsType === 'send') {
            this.props.dispatch({type: 'RECORDER_CANCEL_RECORD'})
        }
    }

    handleYes() {
        window.location = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.lizhiweike';
    }

    render() {
        const {confirmStyle} = this.state;
        const {showNoListenDialog, noTipsType} = this.props;

        return (
            <div className="classroom-nolisten-dialog">
                <WKDialog
                    show={showNoListenDialog}
                    confirmStyle={confirmStyle}>
                    {noTipsType === 'listen' &&
                    <div className="tips-container">
                        <p className="tips-img"><img alt="" src={tipsImg}/></p>
                        <p className="tips-title">直播时听不到声音怎么办？</p>
                        <div className="tips-content">
                            <p className="tips-item">
                                1. 点击语音条后，一直转圈，请尝试靠近WiFi或切换4G；
                            </p>
                            <p className="tips-item">
                                2. 点击语音条后，进度条移动，却没有声音，请检查手机是否开启了静音；
                            </p>
                            <p className="tips-item">
                                3. 如果以上方法无法解决，请点击“下载APP”收听。
                            </p>
                        </div>
                    </div>
                    }

                    {noTipsType === 'send' &&
                    <div className="tips-container">
                        <p className="tips-img"><img alt="" src={sendImg}/></p>
                        <p className="tips-title">直播时发不出内容怎么办？</p>
                        <div className="tips-content">
                            <p className="tips-item">
                                1. 请尝试靠近Wi-Fi或切换至4G网络，再点击语音条右侧的“...”按钮选择重新发送
                            </p>
                            <p className="tips-item">
                                2. 重发失败的，请点击页面右上角刷新页面后再尝试重发
                            </p>
                            <p className="tips-item">
                                3. 若以上方法仍未解决，请“下载APP”进行讲课
                            </p>
                        </div>
                    </div>
                    }
                </WKDialog>
            </div>
        )
    }
}

export default connect((state) => ({
    showNoListenDialog: state.classroom.showNoListenDialog,
    noTipsType: state.classroom.noTipsType
}))(ClassroomNoListenDialog)


// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomNoListenDialog.js